<!-- [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5" [delay]="'300'" -->
<div class="www-pro-edu-tra-tic">
  <h2 class="www-pro-edu-tra-tic__tit">REZERWACJA MIEJSC</h2>

  <div class="www-pro-edu-tra-tic__list d-block d-md-none" id="eduswiper">
    <swiper-container [config]="swiperConfig" wwwSwiper init="false" #swiper>
      @for (event of trainingDetails()!.events; track $index) {
        <swiper-slide [ngClass]="{ 'www-pro-edu-tra-tic__list__swi__sl': true }" swiperSlide role="button">
          <div class="www-pro-edu-tra-tic__list__tile row expanded" [ngClass]="{ soldout: event.free_seats < 1 }">
            <div class="col-12 col-md-1">
              <div class="www-pro-edu-tra-tic__list__tile__col">
                <div class="www-pro-edu-tra-tic__list__tile__col__tit">DATA</div>
                <span class="d-inline d-md-none"
                  >{{ event.start_date | date: 'dd.MM.yyyy' }} | {{ event.start_date | date: 'HH:mm' }}</span
                >
                <span class="d-none d-md-inline">{{ event.start_date | date: 'dd.MM.yyyy' }}</span>
              </div>
            </div>
            <div class="d-none d-md-flex col-12 col-md-2">
              <div class="www-pro-edu-tra-tic__list__tile__col">
                {{ (event.start_date | date: 'HH:mm') + ' - ' + (event.end_date | date: 'HH:mm') }}
              </div>
            </div>
            @if (event.place) {
              <div
                class="col-12 col-md-3"
                [ngClass]="{ 'col-md-2': trainingDetails()?.variants?.length }"
                id="localization"
              >
                <div class="www-pro-edu-tra-tic__list__tile__col__tit">LOKALIZACJA</div>
                <div class="www-pro-edu-tra-tic__list__tile__col">
                  {{ (event.place.name !== 'ONLINE' ? event.place.city + ', ' : '') + event.place.name }}
                </div>
              </div>
            }

            <div class="col-12 col-md-2" id="price">
              <div class="www-pro-edu-tra-tic__list__tile__col__tit">CENA</div>
              <div class="www-pro-edu-tra-tic__list__tile__col">
                @if (trainingDetails()!.price === 0) {
                  {{
                    trainingDetails().slug === 'sniadanie-networkingowe'
                      ? 'Szkolenie na zaproszenie'
                      : 'Szkolenie bezpłatne'
                  }}
                } @else {
                  @if (user()) {
                    <span>
                      <s>{{
                        event.price
                          ? (event.price | mask: 'separator.2')
                          : (trainingDetails()!.price | mask: 'separator.2') + ' PLN'
                      }}</s
                      >&nbsp;{{
                        user()?.type === UserType.MEMBER
                          ? (event.price
                              ? (event.price * 0.9 | mask: 'separator.2')
                              : (trainingDetails()!.price * 0.9 | mask: 'separator.2')) + ' PLN'
                          : (event.price
                              ? (event.price * 0.8 | mask: 'separator.2')
                              : (trainingDetails()!.price * 0.8 | mask: 'separator.2')) + ' PLN'
                      }}
                    </span>
                  } @else {
                    <span>{{
                      trainingDetails()!.price > 0
                        ? event.price
                          ? (event.price | mask: 'separator.2')
                          : (trainingDetails()!.price | mask: 'separator.2') + ' PLN' + ' PLN'
                        : 'Szkolenie bezpłatne'
                    }}</span>
                  }
                }
              </div>
            </div>
            @if (trainingDetails()?.variants?.length) {
              <div class="col-12 col-md-1" id="variant">
                <div class="www-pro-edu-tra-tic__list__tile__col__tit">Wariant</div>
                <div class="www-pro-edu-tra-tic__list__tile__col">{{ event?.variant }}</div>
              </div>
            }

            <div class="col-12 col-md-1" [ngClass]="{ 'd-none': !user() }" id="seats">
              <div class="www-pro-edu-tra-tic__list__tile__col__tit">MIEJSCA</div>
              <div class="www-pro-edu-tra-tic__list__tile__col">{{ event.free_seats + '/' + event.seats }}</div>
            </div>
            <div class="col-12 col-md-3 d-flex justify-content-center align-items-center">
              <div class="www-pro-edu-tra-tic__list__tile__col">
                @if (trainingDetails().slug === 'sniadanie-networkingowe') {
                  <button
                    class="www-pro-edu-tra-tic__list__tile__col__btn disabled-imitation"
                    [ngClass]="{ 'is-in-cart': event.isEventInCart }"
                    (click)="networkingEventCommunicate()"
                    appGtmClick
                    [layer]="{
                      event: 'uaevent',
                      ecommerce: 'undefined',
                      eventCategory: 'trainings list',
                      eventAction: 'select::' + trainingDetails().name + event.start_date + '-' + event.end_date,
                      eventLabel: 'add to cart',
                      event_name: 'body_button_click',
                      module_name: trainingDetails().name + event.start_date + '-' + event.end_date,
                      cta_name: 'add to cart',
                      link_url: '',
                    }"
                  >
                    {{ event.isEventInCart ? 'w koszyku' : event.free_seats > 0 ? 'rezerwuj miejsce' : 'brak miejsc' }}
                  </button>
                } @else {
                  @if (user()) {
                    <button
                      class="www-pro-edu-tra-tic__list__tile__col__btn"
                      [ngClass]="{ 'is-in-cart': event.isEventInCart }"
                      [disabled]="event.free_seats < 1 || !hasAccessToEvent()"
                      (click)="addEventToOrder(event)"
                      appGtmClick
                      [layer]="{
                        event: 'uaevent',
                        ecommerce: 'undefined',
                        eventCategory: 'trainings list',
                        eventAction: 'select::' + trainingDetails().name + event.start_date + '-' + event.end_date,
                        eventLabel: 'add to cart',
                        event_name: 'body_button_click',
                        module_name: trainingDetails().name + event.start_date + '-' + event.end_date,
                        cta_name: 'add to cart',
                        link_url: '',
                      }"
                    >
                      {{
                        event.isEventInCart ? 'w koszyku' : event.free_seats > 0 ? 'rezerwuj miejsce' : 'brak miejsc'
                      }}
                    </button>
                  } @else {
                    <a
                      class="www-pro-edu-tra-tic__list__tile__col__btn"
                      [routerLink]="['/', WwwRouteSlug.LOGIN]"
                      appGtmClick
                      [layer]="{
                        event: 'uaevent',
                        ecommerce: 'undefined',
                        eventCategory: 'trainings details page',
                        eventAction: 'select::go to login page',
                        eventLabel: 'go to login page::' + '/' + WwwRouteSlug.LOGIN,
                        event_name: 'body_button_click',
                        module_name: 'go to login page',
                        cta_name: 'go to login page',
                        link_url: '/' + WwwRouteSlug.LOGIN,
                      }"
                      >zaloguj się</a
                    >
                  }
                }
                @if (hasAccessToEvent()) {
                  <div class="www-pro-edu-tra-tic__list__tile__col__ava">
                    <div
                      class="www-pro-edu-tra-tic__list__tile__col__ava__item"
                      [ngClass]="{
                        green: event!.free_seats / event!.seats >= 0.8,
                        orange: event!.free_seats / event!.seats < 0.8 && event!.free_seats / event!.seats >= 0.4,
                        red: event!.free_seats / event!.seats < 0.4,
                      }"
                    ></div>
                    <div
                      class="www-pro-edu-tra-tic__list__tile__col__ava__item"
                      [ngClass]="{
                        green: event!.free_seats / event!.seats >= 0.8,
                        orange: event!.free_seats / event!.seats < 0.8 && event!.free_seats / event!.seats >= 0.4,
                      }"
                    ></div>
                    <div
                      class="www-pro-edu-tra-tic__list__tile__col__ava__item"
                      [ngClass]="{ green: event!.free_seats / event!.seats > 0.8 }"
                    ></div>
                  </div>
                } @else {
                  <div class="www-pro-edu-tra-tic__list__tile__col__ava">
                    <div class="www-pro-edu-tra-tic__list__tile__col__ava__item red"></div>
                    <div class="www-pro-edu-tra-tic__list__tile__col__ava__item red"></div>
                    <div class="www-pro-edu-tra-tic__list__tile__col__ava__item red"></div>
                  </div>
                }
              </div>
            </div>
          </div>
        </swiper-slide>
      }
    </swiper-container>

    <div class="www-pro-edu-tra-tic__list__swi__nav">
      <div class="www-pro-edu-tra-tic__list__swi__nav--prev"></div>
      <div class="www-pro-edu-tra-tic__list__swi__nav--pag"></div>
      <div class="www-pro-edu-tra-tic__list__swi__nav--next"></div>
    </div>
  </div>

  <div class="www-pro-edu-tra-tic__list d-none d-md-block">
    @for (event of trainingDetails()!.events; track $index) {
      <div
        class="www-pro-edu-tra-tic__list__tile row expanded"
        [ngClass]="{ soldout: event.free_seats < 1, marked: markedEvent()?.id === event.id }"
        [id]="'event' + event.id"
      >
        <div class="col-12 col-md-1" [ngClass]="{ 'col-md-2': !event.place }">
          <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
            <div class="www-pro-edu-tra-tic__list__tile__col__tit">DATA</div>
            <span class="d-inline d-md-none"
              >{{ event.start_date | date: 'dd.MM.yyyy' }} | {{ event.start_date | date: 'HH:mm' }}</span
            >
            <span class="d-none d-md-inline">{{ event.start_date | date: 'dd.MM.yyyy' }}</span>
          </div>
        </div>
        <div
          class="d-none d-md-flex col-12 col-md-1"
          [ngClass]="{
            'col-md-3': !trainingDetails()?.variants?.length && !event.place,
            'col-md-2':
              (!trainingDetails()?.variants?.length && event.place) ||
              (trainingDetails()?.variants?.length && !event.place),
          }"
        >
          <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
            {{ (event.start_date | date: 'HH:mm') + ' - ' + (event.end_date | date: 'HH:mm') }}
          </div>
        </div>
        @if (event.place) {
          <div class="col-12 col-md-3" id="localization">
            <div class="www-pro-edu-tra-tic__list__tile__col__tit">LOKALIZACJA</div>
            <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
              {{ (event.place.name !== 'ONLINE' ? event.place.city + ', ' : '') + event.place.name }}
            </div>
          </div>
        }
        @if (trainingDetails()?.variants?.length && event.variant) {
          <div class="col-12 col-md-1" id="variant">
            <div class="www-pro-edu-tra-tic__list__tile__col__tit">Wariant</div>
            <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
              {{ event?.variant }}
            </div>
          </div>
        }
        <div class="col-12 col-md-2" [ngClass]="{ 'col-md-3': !event.place }" id="price">
          <div class="www-pro-edu-tra-tic__list__tile__col__tit">CENA</div>
          <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
            @if (trainingDetails()!.price === 0) {
              {{
                trainingDetails().slug === 'sniadanie-networkingowe'
                  ? 'Szkolenie na zaproszenie'
                  : 'Szkolenie bezpłatne'
              }}
            } @else {
              @if (user()) {
                <span>
                  <s>{{
                    event.price
                      ? (event.price | mask: 'separator.2')
                      : (trainingDetails()!.price | mask: 'separator.2') + ' PLN'
                  }}</s
                  >&nbsp;{{
                    user()?.type === UserType.MEMBER
                      ? (event.price
                          ? (event.price * 0.9 | mask: 'separator.2')
                          : (trainingDetails()!.price * 0.9 | mask: 'separator.2')) + ' PLN'
                      : (event.price
                          ? (event.price * 0.8 | mask: 'separator.2')
                          : (trainingDetails()!.price * 0.8 | mask: 'separator.2')) + ' PLN'
                  }}
                </span>
              } @else {
                <span>{{
                  trainingDetails()!.price > 0
                    ? event.price
                      ? (event.price | mask: 'separator.2')
                      : (trainingDetails()!.price | mask: 'separator.2') + ' PLN'
                    : 'Szkolenie bezpłatne'
                }}</span>
              }
            }
          </div>
        </div>
        @if (user()) {
          <div class="col-12 col-md-1" id="seats">
            <div class="www-pro-edu-tra-tic__list__tile__col__tit">MIEJSCA</div>
            <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
              {{ event.free_seats + '/' + event.seats }}
            </div>
          </div>
        }

        <div
          class="col-12 col-md-3 d-flex justify-content-center align-items-center"
          [ngClass]="{ 'col-md-4': !user() }"
        >
          <div class="www-pro-edu-tra-tic__list__tile__col" [ngClass]="{ min: trainingDetails()?.variants?.length }">
            @if (trainingDetails().slug === 'sniadanie-networkingowe') {
              <button
                class="www-pro-edu-tra-tic__list__tile__col__btn disabled-imitation"
                [ngClass]="{ 'is-in-cart': event.isEventInCart }"
                (click)="networkingEventCommunicate()"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'trainings list',
                  eventAction: 'select::' + trainingDetails().name + event.start_date + '-' + event.end_date,
                  eventLabel: 'add to cart',
                  event_name: 'body_button_click',
                  module_name: trainingDetails().name + event.start_date + '-' + event.end_date,
                  cta_name: 'add to cart',
                  link_url: '',
                }"
              >
                {{ event.isEventInCart ? 'w koszyku' : event.free_seats > 0 ? 'rezerwuj miejsce' : 'brak miejsc' }}
              </button>
            } @else {
              @if (user()) {
                <button
                  class="www-pro-edu-tra-tic__list__tile__col__btn"
                  [ngClass]="{ 'is-in-cart': event.isEventInCart }"
                  [disabled]="event.free_seats < 1 || !hasAccessToEvent()"
                  (click)="addEventToOrder(event)"
                  appGtmClick
                  [layer]="{
                    event: 'uaevent',
                    ecommerce: 'undefined',
                    eventCategory: 'trainings list',
                    eventAction: 'select::' + trainingDetails().name + event.start_date + '-' + event.end_date,
                    eventLabel: 'add to cart',
                    event_name: 'body_button_click',
                    module_name: trainingDetails().name + event.start_date + '-' + event.end_date,
                    cta_name: 'add to cart',
                    link_url: '',
                  }"
                >
                  {{ event.isEventInCart ? 'w koszyku' : event.free_seats > 0 ? 'rezerwuj miejsce' : 'brak miejsc' }}
                </button>
              } @else {
                <a
                  class="www-pro-edu-tra-tic__list__tile__col__btn"
                  [routerLink]="['/', WwwRouteSlug.LOGIN]"
                  appGtmClick
                  [layer]="{
                    event: 'uaevent',
                    ecommerce: 'undefined',
                    eventCategory: 'trainings details page',
                    eventAction: 'select::go to login page',
                    eventLabel: 'go to login page::' + '/' + WwwRouteSlug.LOGIN,
                    event_name: 'body_button_click',
                    module_name: 'go to login page',
                    cta_name: 'go to login page',
                    link_url: '/' + WwwRouteSlug.LOGIN,
                  }"
                  >zaloguj się</a
                >
              }
            }
            @if (user()) {
              @if (hasAccessToEvent()) {
                <div class="www-pro-edu-tra-tic__list__tile__col__ava">
                  <div
                    class="www-pro-edu-tra-tic__list__tile__col__ava__item"
                    [ngClass]="{
                      green: event!.free_seats / event!.seats >= 0.8,
                      orange: event!.free_seats / event!.seats < 0.8 && event!.free_seats / event!.seats >= 0.4,
                      red: event!.free_seats / event!.seats < 0.4,
                    }"
                  ></div>
                  <div
                    class="www-pro-edu-tra-tic__list__tile__col__ava__item"
                    [ngClass]="{
                      green: event!.free_seats / event!.seats >= 0.8,
                      orange: event!.free_seats / event!.seats < 0.8 && event!.free_seats / event!.seats >= 0.4,
                    }"
                  ></div>
                  <div
                    class="www-pro-edu-tra-tic__list__tile__col__ava__item"
                    [ngClass]="{ green: event!.free_seats / event!.seats > 0.8 }"
                  ></div>
                </div>
              } @else {
                <div class="www-pro-edu-tra-tic__list__tile__col__ava">
                  <div class="www-pro-edu-tra-tic__list__tile__col__ava__item red"></div>
                  <div class="www-pro-edu-tra-tic__list__tile__col__ava__item red"></div>
                  <div class="www-pro-edu-tra-tic__list__tile__col__ava__item red"></div>
                </div>
              }
            } @else {
              <div class="www-pro-edu-tra-tic__list__tile__col__ava">
                <div class="www-pro-edu-tra-tic__list__tile__col__ava__item green"></div>
                <div class="www-pro-edu-tra-tic__list__tile__col__ava__item green"></div>
                <div class="www-pro-edu-tra-tic__list__tile__col__ava__item green"></div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  @if (trainingDetails()!.events.length < 1) {
    <p class="text-center">Brak biletów na wydarzenie</p>
  }
</div>

<!-- green: event!.free_seats / event!.seats > 0.65,
orange: event!.free_seats / event!.seats <= 0.65 && event!.free_seats / event!.seats > 0.33,
red: event!.free_seats / event!.seats <= 0.33, -->
